export default __webpack_public_path__ + "static/media/icon-sound.93a382f7.svg";